import apiFetch from '../apiFetch'

export default function (organizedUnitId, token) {
  return apiFetch({ endPoint: `deliveryLocation/Default?organizedUnitId=${organizedUnitId}`, method: 'GET', body: null, token: token })
}
